import { render, staticRenderFns } from "./SucursalesSelectName.vue?vue&type=template&id=22b7b5c6&scoped=true&"
import script from "./SucursalesSelectName.vue?vue&type=script&lang=js&"
export * from "./SucursalesSelectName.vue?vue&type=script&lang=js&"
import style0 from "./SucursalesSelectName.vue?vue&type=style&index=0&id=22b7b5c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b7b5c6",
  null
  
)

component.options.__file = "SucursalesSelectName.vue"
export default component.exports